import * as tslib_1 from "tslib";
import { CdkAccordionItem } from '@angular/cdk/accordion';
import { TemplateRef, } from '@angular/core';
import { MatExpansionPanelState, } from '@angular/material/expansion';
var UiSidebarAccordionComponent = /** @class */ (function (_super) {
    tslib_1.__extends(UiSidebarAccordionComponent, _super);
    function UiSidebarAccordionComponent() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.isActive = false;
        _this.headerText = '';
        _this.headerTooltip = '';
        _this.pages = [];
        return _this;
    }
    Object.defineProperty(UiSidebarAccordionComponent.prototype, "accordionState", {
        get: function () {
            return this.expanded ? 'expanded' : 'collapsed';
        },
        enumerable: true,
        configurable: true
    });
    return UiSidebarAccordionComponent;
}(CdkAccordionItem));
export { UiSidebarAccordionComponent };
